import { BranchState } from './branch-reducer';
import { BranchActions, BRANCH_ACTION_TYPE } from './branch-type';

export const branchCreators = {
  setBranchState: <KeyName extends keyof BranchState>(key: KeyName, value: BranchState[KeyName])
    : BranchActions => ({
      type: BRANCH_ACTION_TYPE.SET_BRANCH_STATE,
      payload: { key, value }
    }),
  callBranch: () => ({
    type: BRANCH_ACTION_TYPE.CALL_BRANCH
  }),
  callVat: (call: any) => ({
    type: BRANCH_ACTION_TYPE.CALL_VAT,
    callback: call
  })
};
